import { callFunction } from './callableClient'
import type {
  FulfillmentTaskListItem,
  FulfillmentTaskDetail,
  TaskStatus,
  WineSalesMonthly,
} from '../types/fulfillment'

type GetTasksResponse = {
  tasks: FulfillmentTaskListItem[]
  wineSalesMonthly?: WineSalesMonthly
}

type GetTaskByIdResponse = {
  task: FulfillmentTaskDetail
}

type UpdateStatusResponse = {
  ok: boolean
  status: TaskStatus
}

export async function getPartnerTasks(): Promise<{
  tasks: FulfillmentTaskListItem[]
  wineSalesMonthly: WineSalesMonthly
}> {
  const result = await callFunction<undefined, GetTasksResponse>('partnerGetTasks')
  const wineSalesMonthly: WineSalesMonthly = result.wineSalesMonthly ?? {
    categories: ['—', '—', '—', '—', '—', '—'],
    series: [{ name: 'Outros', data: [0, 0, 0, 0, 0, 0] }],
    momTotalPercent: null,
  }
  return { tasks: result.tasks, wineSalesMonthly }
}

export async function getPartnerTaskById(taskId: string): Promise<FulfillmentTaskDetail> {
  const result = await callFunction<{ taskId: string }, GetTaskByIdResponse>(
    'partnerGetTaskById',
    { taskId }
  )
  return result.task
}

export async function updateTaskStatus(
  taskId: string,
  newStatus: TaskStatus,
  extra?: { trackingCode?: string; carrier?: string }
): Promise<void> {
  await callFunction<{
    taskId: string
    newStatus: TaskStatus
    trackingCode?: string
    carrier?: string
  }, UpdateStatusResponse>('partnerUpdateTaskStatus', {
    taskId,
    newStatus,
    ...extra,
  })
}
